module.exports = __webpack_public_path__ + "img/step18_a_printer_basic_place_on_stand.a2c71d7b.png";